import React from 'react';
import moize from 'moize';
import Checkbox from '@material-ui/core/Checkbox';

const FileExplorerCheckbox = ({ isSelected }: { isSelected: boolean }) =>
  <Checkbox className="checkbox" checked={isSelected} />;

export default moize.react(FileExplorerCheckbox, { maxSize: 2 });
